/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   button.pop-over-help[_ngcontent-%COMP%]{border:none;background:0 0;position:absolute;z-index:10;top:11px;right:10px;font-size:2rem;color:#ff720a}[_nghost-%COMP%]   button.pop-over-help.static[_ngcontent-%COMP%]{position:static!important}[_nghost-%COMP%]   button.pop-over-help.smaller[_ngcontent-%COMP%]{-webkit-transform:scale(.8,.8);transform:scale(.8,.8)}[_nghost-%COMP%]   button.pop-over-help[_ngcontent-%COMP%]   .fa-question-circle.bg-blue[_ngcontent-%COMP%]{color:#002974}"];
export { styles as styles };
